import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Heading from '@deliveroo/consumer-component-library/components/Heading';
import P from '@deliveroo/consumer-component-library/components/P';

import styles from './styles.scss';

export default function OrderHelpIntro({ contentHeader, contentText, isHeartStyleIntro }) {
  if (!contentHeader && !contentText) {
    return null;
  }

  return (
    <Fragment>
      {isHeartStyleIntro && <div className={styles.heart} />}
      <div className={isHeartStyleIntro ? styles['center-text'] : ''}>
        {contentHeader && (
          <Heading level={3} size="x-small">
            {contentHeader}
          </Heading>
        )}

        {contentText && (
          <P adjacentVerticalSpacing="medium">
            <span
              // contentText comes from our API response which can trust
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: contentText,
              }}
            />
          </P>
        )}
      </div>
    </Fragment>
  );
}

OrderHelpIntro.defaultProps = {
  contentHeader: '',
  contentText: '',
  isHeartStyleIntro: false,
};

OrderHelpIntro.propTypes = {
  /**
   * The header for the content within the self help page
   */
  contentHeader: PropTypes.string,
  /**
   * The text for the content within the self help page
   */
  contentText: PropTypes.string,
  /**
   * Whether to show the heart style seen for RESOLUTION_SELECTION templates
   */
  isHeartStyleIntro: PropTypes.bool,
};
